import { BASE_URL } from '../constants'

import useRecurrantFetch from '../hooks/useRecurrantFetch'
import { useToken } from '../auth/hooks'

export const useIncidents = () => {
  const token = useToken()
  return useRecurrantFetch(`${BASE_URL}api/hcfrIncidents`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  })
}
